import axios from '@axios'

const PREFIX = '/etiquetas'

export default {
  getEtiquetas(filtros) {
    return axios.post(`${PREFIX}/resumido`, filtros)
  },

  getEtiquetasProposta(propostaId) {
    return axios.get(`${PREFIX}/etiquetas-proposta/${propostaId}`)
  },

  adicionarEtiquetaManual(etiqueta) {
    return axios.post(`${PREFIX}/add`, etiqueta)
  },

  atualizarEtiqueta(etiqueta) {
    return axios.put(`${PREFIX}/update`, etiqueta)
  },

  removerEtiqueta(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  cadastrarEtiquetaProposta(etiqueta, propostaid) {
    return axios.post(`${PREFIX}/${propostaid}`, etiqueta)
  },

  removerEtiquetaProposta(etiquetaid, propostaid) {
    return axios.delete(`${PREFIX}/remove-etiqueta-proposta?etiquetaid=${etiquetaid}&propostaid=${propostaid}`)
  },

}
